import React from 'react';

import {
  Badge,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Show,
  Text,
} from '@vimeo/bokeh';
import { translate } from '@vimeo/i18n-runtime';

export function AdvertBadge() {
  return (
    <>
      <Show below="md">
        <Badge
          variant="not-yet-rated"
          size="sm"
          color="text-secondary"
          borderColor="text-secondary"
        >
          Ad
        </Badge>
      </Show>
      <Show above="md">
        <Popover placement="top" trigger="hover">
          <PopoverTrigger>
            <Badge
              variant="not-yet-rated"
              size="sm"
              color="text-secondary"
              borderColor="text-secondary"
            >
              {translate('Ad')}
            </Badge>
          </PopoverTrigger>
          <PopoverContent maxW={320} py={75} px={100}>
            <PopoverBody>
              <Text textAlign="center" variant="body-md">
                {translate('This video contains an advertisement.')}
              </Text>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      </Show>
    </>
  );
}
